import { getSessionUUID } from '../components/lib/AuthToken';
import logger from "../utils/logger";

export const fetch_todays_defects = async () => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/defects/get_todays_defects', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody.data || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching defects:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_outstanding_defects = async () => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/defects/get_outstanding_defects', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody.data || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching defects:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


//-------------------------------------------------------------------------------------------------

export const repair_defect = async (repair, uuid) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        const user_uuid = uuid || '';

        logger.log("***repair: ", repair);

        const repair_data = {
            repairer_id: user_uuid,
            defect_uuid: repair.defect_uuid,
            vehicle_check_uuid: repair.vehicle_check_uuid,
            defect_type: repair.defect_type,
            status: repair.status,
            comment: repair.comment,
        };

        logger.log("****sending repair data to backend", repair_data);

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ repair_data })
        };

        // Send Request to backend
        const response = await fetch('/defects/update_defect', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: response.message || 'Defect Update successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating vehiclee:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};